import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";

/** Pass untouched request through to the next request handler. */
@Injectable()
export class XSRFHeaderInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const tokenInput: HTMLInputElement = document.querySelector('input[name="__RequestVerificationToken"]');
    const modifiedReq = req.clone({
      headers: req.headers
        .set(
          "X-XSRF-Token",
          tokenInput ? tokenInput.value.toString() : ''
        )
        .set("Cache-Control", "no-cache")
        .set("Pragma", "no-cache"),
        withCredentials: true
    });
    return next.handle(modifiedReq);
  }
}
